import { CircularProgress } from '@material-ui/core'

const LoadingAnimation = (): JSX.Element => {
  return <CircularProgress color="primary" />
}

export default LoadingAnimation
